const PREVIEW_TYPE_BY_EXTENSION = Object.freeze({
  pdf: "pdf",
  jpg: "image",
  jpeg: "image",
  png: "image",
  gif: "image",
  webp: "image",
  avif: "image",
  mp4: "video",
  webm: "video",
  mp3: "audio",
  wav: "audio",
  ogg: "audio",
  doc: "office",
  docx: "office",
  xls: "office",
  xlsx: "office",
  ppt: "office",
  pptx: "office",
  txt: "text",
  csv: "text",
});

function get_file_source(document = {}) {
  return document?.file || document;
}

function get_file_url(file) {
  if (typeof file === "string") return file;
  return file?.url || file?.file_url || file?.s3_url || "";
}

function get_file_name(document, file, url) {
  const fallbackName = String(url || "").split("/").pop() || "";
  return String(file?.name || document?.name || fallbackName)
    .split("?")[0]
    .toLowerCase();
}

export function get_preview_details(document = {}) {
  const file = get_file_source(document);
  const url = get_file_url(file);
  const file_name = get_file_name(document, file, url);
  const extension = file_name.split(".").pop();

  return {
    url,
    type: Reflect.get(PREVIEW_TYPE_BY_EXTENSION, extension) || "other",
    extension,
    file_name,
  };
}

export function open_preview(vm, previewDocument, modal_id = "preview_modal") {
  const { url, type } = get_preview_details(previewDocument);

  vm.preview_url = url;
  vm.preview_type = type;
  vm.loading_preview = true;

  $(`#${modal_id}`).modal("show");
}
